<span class="title" mat-dialog-title>{{data?.mode === 'railtravel' ? 'Fahrtdetail' : 'Flugdetail'}}</span>
<mat-dialog-content class="customscroll" [class.custom]="data?.mobile">
    @if(myflight.outbound) {
        <div class="f-wrappper">
            <div class="cccc988">
                @if(myflight?.outbound) {
                <div class="ccc3">
                    <span class="cc3">{{data?.mode === 'railtravel' ? 'Hinfahrt' : 'Hinflug'}}</span>
                    <div class="ccc4">
                        @if(myflight?.outbound?.directFlug) {
                        <span class="ftime"> {{data?.mode === 'railtravel' ? 'Direktfahrt': 'Direktflug'}}</span>
                        } @else {
                        <span class="ftime"> {{myflight?.inbound?.stopovers}} Stop</span>
                        }
                        <span class="ftime ml5">{{myflight?.outbound?.estimatedElapsedTime}} Std.</span>
                    </div>
                </div>
                <div class="f-body">
                    @for (flgt of myflight?.outbound?.legList; track $index) {
                        <div class="ff1" [class.ff1m]="data?.mobile">
                            <div class="ff2">
                                <div>
                                    <mat-icon  class="f-ico">{{data?.mode ===
                                        'railtravel' ? 'train': 'flight_takeoff'}}</mat-icon>
                                </div>
                                <div class="cc1">
                                    <span class="cc2">{{flgt?.departureDateWeek}} {{flgt.departureDate | date}} {{flgt?.departureTime}}</span>
                                    <span class="ccc5">{{flgt.departureAirportName}} {{flgt?.departureAirportCode}}</span>
                                </div>
                            </div>
                            <div class="ff3" [class.ff3m]="data?.mobile">
                                <div [matTooltip]="flgt?.flightCarrierName">
                                    <img class="lazyload" data-src="{{'https://media.traffics-switch.de/vadata/air_logo/png/h100/' + (flgt?.flightCarrierCode)?.toLowerCase() + '.png'}}"
                                            (error)="handelError(flgt)" height="15px"
                                            alt="{{flgt?.flightCarrierName}}">
                                </div>
                                <div>
                                    <ng-container *ngIf="data?.mode !== 'railtravel' else railOu">
                                        <span class="ftime">
                                            {{flgt?.estimatedElapsedTime}} Std.
                                        </span>
                                    </ng-container>
                                </div>
                            </div>
                            <div class="ff2">
                                <div>
                                    <mat-icon  class="f-ico">{{data?.mode ===
                                        'railtravel' ? 'train': 'flight_land'}}</mat-icon>
                                </div>
                                <div class="cc1">
                                    <span class="cc2">{{flgt?.arrivalDateWeek}} {{flgt.arrivalDate | date}} {{flgt?.arrivalTime}}
                                        @if(flgt.differenceInDays !== '0') {
                                            <sup>{{flgt.differenceInDays + (flgt.differenceInDays === '1' ? 'Tag' : 'Tage')}}</sup>
                                        }
                                    </span>
                                    <span class="ccc5">{{flgt.arrivalAirportName}} {{flgt?.arrivalAirportCode}}</span>
                                </div>
                            </div>
                        </div>
                    }
                </div>
                }
                @if(myflight?.inbound) {
                    <div class="ccc3 mt1">
                        <span class="cc3">{{data?.mode === 'railtravel' ? 'Rückfahrt' : 'Rückflug'}}</span>
                        <div class="ccc4">
                            @if(myflight?.inbound?.directFlug) {
                            <span class="ftime"> {{data?.mode === 'railtravel' ? 'Direktfahrt': 'Direktflug'}}</span>
                            } @else {
                            <span class="ftime"> {{myflight?.inbound?.stopovers}} Stop</span>
                            }
                            <span class="ftime ml5">{{myflight?.inbound?.estimatedElapsedTime}} Std.</span>
                        </div>
                    </div>
                    <div class="f-body">
                        @for (flgt of myflight?.inbound?.legList; track $index) {
                            <div class="ff1" [class.ff1m]="data?.mobile">
                                <div class="ff2">
                                    <div>
                                        <mat-icon  class="f-ico">{{data?.mode ===
                                            'railtravel' ? 'train': 'flight_takeoff'}}</mat-icon>
                                    </div>
                                    <div class="cc1">
                                        <span class="cc2">{{flgt?.departureDateWeek}} {{flgt.departureDate | date}} {{flgt?.departureTime}}</span>
                                        <span class="ccc5">{{flgt.departureAirportName}} {{flgt?.departureAirportCode}}</span>
                                    </div>
                                </div>
                                <div class="ff3" [class.ff3m]="data?.mobile">
                                    <div [matTooltip]="flgt?.flightCarrierName">
                                        <img class="lazyload" data-src="{{'https://media.traffics-switch.de/vadata/air_logo/png/h100/' + (flgt?.flightCarrierCode)?.toLowerCase() + '.png'}}"
                                                (error)="handelError(flgt)" height="15px"
                                                alt="{{flgt?.flightCarrierName}}">
                                    </div>
                                    <div>
                                        <ng-container *ngIf="data?.mode !== 'railtravel' else railOu">
                                            <span class="ftime">
                                                {{flgt?.estimatedElapsedTime}} Std.
                                            </span>
                                        </ng-container>
                                    </div>
                                </div>
                                <div class="ff2">
                                    <div>
                                        <mat-icon  class="f-ico">{{data?.mode ===
                                            'railtravel' ? 'train': 'flight_land'}}</mat-icon>
                                    </div>
                                    <div class="cc1">
                                        <span class="cc2">{{flgt?.arrivalDateWeek}} {{flgt.arrivalDate | date}} {{flgt?.arrivalTime}}
                                            @if(flgt.differenceInDays !== '0') {
                                                <sup>{{flgt.differenceInDays + (flgt.differenceInDays === '1' ? 'Tag' : 'Tage')}}</sup>
                                            }
                                        </span>
                                        <span class="ccc5">{{flgt.arrivalAirportName}} {{flgt?.arrivalAirportCode}}</span>
                                    </div>
                                </div>
                            </div>
                        }
                    </div>
                    }
                <!-- @if(myflight?.inbound) {
                <div class="f-body mt1">
                    @for (flgt of myflight?.inbound?.legList; track $index) {
                    <div>
                        <mat-icon  class="f-ico" [class.rmin]="data?.mode === 'pauschal'">{{data?.mode
                            ===
                            'railtravel' ? 'train': 'flight_takeoff'}}</mat-icon>
                    </div>


                    <div class="cc1">
                        <span class="cc2">{{flgt?.departureDateWeek}} {{flgt.departureDate |
                            date}}</span>

                        <div>
                            <span>{{flgt.departureTime}}</span>
                            <span> &minus; {{flgt.differenceInDays}}<sup>{{(flgt.differenceInDays?.length >
                                    0
                                    ? '+' +
                                    flgt.differenceInDays + (flgt.differenceInDays
                                    === '1' ? 'Tag' : 'Tage') : '')}}</sup></span>

                        </div>

                        <div class="cc3">
                            <ng-container *ngIf="data?.mode !== 'railtravel' else railIn">
                                <span class="ftime">
                                    {{myflight?.inbound?.estimatedElapsedTime}} Std.
                                </span>
                            </ng-container>
                            @if(myflight?.inbound?.directFlug) {
                            <span class="ml3"> {{data?.mode === 'railtravel' ? 'Direktfahrt': 'Direktflug'}}</span>
                            } @else {
                            <span class="ml3"> {{myflight?.inbound?.stopovers}} Stop</span>
                            }
                        </div>
                    </div>
                    }
                </div>
                } -->
            </div>
        </div>
    } @else {
        <div class="f2gwr">
            <ng-container *ngIf="flightOffer" [ngTemplateOutlet]="fliugsAiports"></ng-container>
            <div class="f22er">
                <div class="f2wr">
                    <mat-icon  class="f2ico">
                        warning
                    </mat-icon>
                    <span class="f22t">{{data?.mode === 'railtravel' ? 'Fahrtdaten': 'Flugdaten'}} noch nicht
                        verfügbar</span>
                </div>
                <span class="f2t">bitte auf Angebot auf prüfen
                    klicken</span>
            </div>
        </div>
    }

    <ng-template #railIn>
        <span class="ftime">
            {{myflight?.inbound?.estimatedElapsedTime}} Std.
            {{(myflight?.inbound?.bookingClass?.length > 0 ? ' ' + myflight?.inbound?.bookingClass + ' Klasse | ' :
            '')}}
            {{(myflight?.inbound?.tariff?.length > 0 ? ' ' + (myflight?.inbound?.tariff === 'SPAR' ? 'Sparpreis' :
            'Flexpreis') : '')}}
        </span>
    </ng-template>

    <ng-template #railOu>
        <span class="ftime">
            {{myflight?.outbound?.estimatedElapsedTime}} Std.
            {{(myflight?.outbound?.bookingClass?.length > 0 ? ' ' + myflight?.outbound?.bookingClass + ' Klasse | ' :
            '')}}
            {{(myflight?.outbound?.tariff?.length > 0 ? ' ' + (myflight?.outbound?.tariff === 'SPAR' ? 'Sparpreis' :
            'Flexpreis') : '')}}
        </span>
    </ng-template>

    <ng-template #fliugsAiports>
        <div class="f1wr">
            <span>{{flightOffer?.flight?.departureAirport?.name}}
                ({{flightOffer?.flight?.departureAirport?.code}})</span>
            <mat-icon  class="f1ico">
                sync_alt</mat-icon>
            <span>{{flightOffer?.flight?.arrivalAirport?.name}}
                ({{flightOffer?.flight?.arrivalAirport?.code}})</span>
        </div>
    </ng-template>
</mat-dialog-content>

<mat-dialog-actions align="end">
    <button mat-button mat-dialog-close>OK</button>
</mat-dialog-actions>